import React, { createContext, useContext, useEffect, useState } from "react";

const CookieContext = createContext(null);
const STORAGE_KEY = "nek-cookie-consent";

const DEFAULT = { necessary: true, analytics: false, marketing: false, timestamp: null };

export function CookieProvider({ children }) {
  const [consent, setConsent] = useState(DEFAULT);
  const [decided, setDecided] = useState(true);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        setConsent(JSON.parse(raw));
        setDecided(true);
      } else {
        setDecided(false);
      }
    } catch (e) {
      setDecided(false);
    }
  }, []);

  const persist = (next) => {
    const value = { ...next, necessary: true, timestamp: new Date().toISOString() };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (error) {
      console.warn("Unable to persist cookie preferences:", error);
    }
    setConsent(value);
    setDecided(true);
  };

  const value = {
    consent,
    decided,
    acceptAll: () => persist({ necessary: true, analytics: true, marketing: true }),
    rejectAll: () => persist({ necessary: true, analytics: false, marketing: false }),
    savePreferences: (prefs) => persist({ ...consent, ...prefs }),
    reopen: () => setDecided(false),
  };

  return <CookieContext.Provider value={value}>{children}</CookieContext.Provider>;
}

export function useCookies() {
  const ctx = useContext(CookieContext);
  if (!ctx) throw new Error("useCookies must be used within CookieProvider");
  return ctx;
}
